import { Note } from '@work4all/models/lib/Classes/Note.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/note-table-schema.json';

const defaultSort = [{ field: 'date', direction: SortDirection.DESCENDING }];

export function NotesTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<Note, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    enableURLState: true,
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}
